import { Pagination } from '@foam/buoy/src/components/Pagination/Pagination';
import { useCallback, useMemo, useState } from 'react';
import { ContentSearchSkeleton } from '~/components/ContentSearchSkeleton';
import { useFetchCreatorContent } from '~/hooks/api/useFetchCreatorContent';
import { SearchContentEmpty } from '~/screens/SearchContent/components';
import {
  ISearchContentResult,
  mapApiSearchContentResultsFromApiToVm,
} from '~/searchApi';

import { ContentCard } from '../../blocks/TalentContent/ContentCard/ContentCard';
import { useContentSelection } from '../../blocks/TalentContent/useContentSelection';
import { useAddContentStore } from '../useAddContentStore';

export const AddContentWithMetrics = () => {
  const { setIsContentDetailModalOpen } = useAddContentStore();
  const { creatorId, filters, platforms, sortBy, searchQuery } =
    useAddContentStore();
  const { handleSelectContent, getIsChecked } = useContentSelection();
  const [page, setPage] = useState(1);

  const content = useFetchCreatorContent({
    creatorId: creatorId as string,
    platform: platforms.length > 0 ? platforms : undefined,
    filters: filters,
    orderBy: sortBy,
    searchQuery: searchQuery.length > 0 ? searchQuery : undefined,
    isEnabled: !!creatorId,
    page,
  });

  const transformedContent = useMemo(() => {
    if (!content.data) return [];
    return mapApiSearchContentResultsFromApiToVm(content.data.results);
  }, [content.data]);

  const handleContentDetailOpen = useCallback(
    (content: ISearchContentResult) => {
      setIsContentDetailModalOpen(true, content.contentId);
    },
    [setIsContentDetailModalOpen],
  );

  if (content.isLoading) return <ContentSearchSkeleton />;
  if (content.error) return <p>Error</p>;
  if (content.data?.results.length === 0) {
    return (
      <SearchContentEmpty
        noFilter={
          filters.length === 0 &&
          platforms.length === 0 &&
          sortBy === 'published_at' &&
          searchQuery.length === 0
        }
      />
    );
  }

  return (
    <>
      <div className="flex w-full flex-wrap gap-4 overflow-auto p-1 after:grow-[999] after:content-['']">
        {transformedContent.map((contentItem, index) => {
          const isSelected = getIsChecked(contentItem.id);
          return (
            <div key={contentItem.id} className="relative grow cursor-pointer">
              <ContentCard
                content={contentItem}
                onClick={handleContentDetailOpen}
                isChecked={isSelected}
                onCheckboxChange={(checked) => {
                  handleSelectContent(checked, content.data!.results[index]);
                }}
                showMetrics
              />
            </div>
          );
        })}
      </div>
      <Pagination
        currentPage={page}
        onPageChange={(page) => setPage(page)}
        pageSize={content.data?.meta.size || 0}
        totalCount={content.data?.meta.total || 0}
      />
    </>
  );
};
